import { useConfig } from "../contexts/config-context.js";
import { useForcedState, ForcedState } from "../contexts/forced-state-context.js";
import { useTranslation } from "../contexts/translation-context.js";
import { getDateValidationErrorSuffix } from "../ui/date-field/date-field-utils.js";
import { getDateTimeValidationErrorSuffix } from "../ui/date-time-field/date-time-field-utils.js";
import { getTranslatedError } from "./get-translated-error.js";
import { INPUT_FIELD_TYPES } from "../constants/input-field-types.js";
import "../constants/field-types.js";
const getErrorSuffix = ({
  fieldType,
  error,
  properties
}) => {
  switch (fieldType) {
    case INPUT_FIELD_TYPES.DATE_TIME_INPUT:
      return getDateTimeValidationErrorSuffix(error);
    case INPUT_FIELD_TYPES.CONTACTS_BIRTHDATE:
    case INPUT_FIELD_TYPES.DATE_INPUT:
      return getDateValidationErrorSuffix(error);
    case INPUT_FIELD_TYPES.TEXT_INPUT:
    case INPUT_FIELD_TYPES.CHALLENGES_SHORT_TEXT:
    case INPUT_FIELD_TYPES.QUIZ_TEXT_INPUT:
    case INPUT_FIELD_TYPES.DEXT_TEXT_INPUT:
    case INPUT_FIELD_TYPES.DEXT_EMAIL:
    case INPUT_FIELD_TYPES.CONTACTS_TAX_ID:
    case INPUT_FIELD_TYPES.CONTACTS_POSITION:
    case INPUT_FIELD_TYPES.CONTACTS_LAST_NAME:
    case INPUT_FIELD_TYPES.CONTACTS_FIRST_NAME:
    case INPUT_FIELD_TYPES.CONTACTS_EMAIL:
    case INPUT_FIELD_TYPES.CONTACTS_COMPANY:
    case INPUT_FIELD_TYPES.CONTACTS_ADDRESS:
    case INPUT_FIELD_TYPES.BOOKINGS_LAST_NAME:
    case INPUT_FIELD_TYPES.BOOKINGS_FIRST_NAME:
    case INPUT_FIELD_TYPES.BOOKINGS_EMAIL:
    case INPUT_FIELD_TYPES.ECOM_PHONE:
    case INPUT_FIELD_TYPES.ECOM_EMAIL:
    case INPUT_FIELD_TYPES.ECOM_COMPANY_NAME:
    case INPUT_FIELD_TYPES.ECOM_ADDITIONAL_INFO:
    case INPUT_FIELD_TYPES.FULL_NAME_LAST_NAME:
    case INPUT_FIELD_TYPES.FULL_NAME_FIRST_NAME:
    case INPUT_FIELD_TYPES.MLA_STREET_NAME:
    case INPUT_FIELD_TYPES.MLA_ADDRESS_LINE:
    case INPUT_FIELD_TYPES.MLA_STREET_NUMBER:
    case INPUT_FIELD_TYPES.MLA_POSTAL_CODE:
    case INPUT_FIELD_TYPES.MLA_CITY:
    case INPUT_FIELD_TYPES.MLA_APARTMENT:
    case INPUT_FIELD_TYPES.MLA_ADDRESS_LINE_2:
    case INPUT_FIELD_TYPES.PASSWORD:
    case INPUT_FIELD_TYPES.RATING_INPUT:
    case INPUT_FIELD_TYPES.DEXT_RATING_INPUT:
    case INPUT_FIELD_TYPES.MLA_COUNTRY:
    case INPUT_FIELD_TYPES.MLA_SUBDIVISION:
      if (properties && "countryCode" in properties) {
        const countryCode = properties.countryCode;
        return typeof countryCode === "string" ? countryCode.toLocaleLowerCase() : void 0;
      }
      return void 0;
    case INPUT_FIELD_TYPES.VAT_ID:
      if (properties && "country" in properties) {
        const country = properties.country;
        return typeof country === "string" ? country.toLocaleLowerCase() : void 0;
      }
      return void 0;
    case INPUT_FIELD_TYPES.SIGNATURE:
      if (properties && "uploadEnabled" in properties) {
        return properties.uploadEnabled ? "with-upload" : void 0;
      }
      return void 0;
    default:
      return void 0;
  }
};
const useError = ({
  error,
  customErrors,
  fieldType,
  properties,
  validationError
}) => {
  const { currency } = useConfig();
  const { t, i18n } = useTranslation();
  const forcedState = useForcedState();
  if (forcedState.includes(ForcedState.INPUT_FIELDS_ERROR)) {
    return {
      hasError: true,
      errorMessage: t("input.error.message.required-error-forced")
    };
  }
  if (!error) {
    return { hasError: false };
  }
  const customErrorMessage = error?.useCustomErrorMessage && error?.errorMessage || customErrors?.[error.errorType];
  const suffix = fieldType ? getErrorSuffix({
    fieldType,
    error: validationError,
    properties
  }) : void 0;
  const errorMessage = customErrorMessage ?? getTranslatedError({
    translation: { i18n, t },
    error,
    fieldType,
    suffix,
    currency: currency?.sign
  });
  return { hasError: true, errorMessage };
};
export {
  useError
};
//# sourceMappingURL=use-error.js.map
